import React, { useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

export default function PhotoGallery({ items }) {
    const [isModalOpen, setModalOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);

    const openModal = (image) => {
        setCurrentImage(image);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setCurrentImage(null);
    };

    return (
        <>
            <Carousel
                showStatus={false}
                showThumbs={items?.length > 1}  // Conditionally show thumbnails based on item length
                showIndicators={items?.length > 1}  // Hide dots if there is only one item
                showArrows
                swipeable
                // dynamicHeight
                preventMovementUntilSwipeScrollTolerance
                swipeScrollTolerance={30} // Adjust swipe sensitivity
                selectedItem={0}
                // infiniteLoop
                >
                {items?.map((item, index) => (
                    <div
                    key={index}
                    className="flex w-full h-full justify-center items-center cursor-pointer"
                    onClick={() => openModal(item)}
                    >
                    <img
                        className="max-h-96 object-contain"
                        src={item}
                        alt={`Slide ${index + 1}`}
                    />
                    </div>
                ))}
            </Carousel>

            {isModalOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50"
                    onClick={closeModal}
                >
                    <img
                        src={currentImage}
                        alt="Enlarged"
                        className="max-w-full max-h-full object-contain"
                    />
                </div>
            )}
        </>
    );
}
